import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useFeature } from '../../contexts/FeatureContext';

// Component to protect routes based on feature status
export const FeatureProtectedRoute = ({ featureId }) => {
  const { isFeatureEnabled, loading } = useFeature();
  
  // If still loading feature status, show nothing (or could show a loading spinner)
  if (loading) {
    return null;
  }
  
  // Check if the feature is enabled
  if (!isFeatureEnabled(featureId)) {
    // Redirect to the coming-soon page for this feature
    return <Navigate to={`/${featureId}/coming-soon`} replace />;
  }
  
  // If feature is enabled, render the child routes
  return <Outlet />;
};
